@let obs =
  {
    isOpened: isOpened(),
    isDesktopUp: isDesktopUp$ | async,
    showNavArrow: showNavArrow$ | async,
    isModalType: type === 'modal',
    showOverlay: showOverlay$ | async,
  };

@if (obs.showOverlay) {
  <div class="search-expand-overlay" (click)="onOverlayClick($event)"></div>
}

<form
  ngNoForm
  data-analytics="search_form"
  class="search search-form search-form-{{ type }}"
  [class.opened]="obs.isOpened"
  [class.filled]="searchInputControl.value"
  [class.expanded]="isExpanded()"
  (submit)="$event.preventDefault()"
>
  <div class="search-input-wrapper">
    @if (obs.showNavArrow && obs.isModalType) {
      <div class="search-input-left-side">
        <button
          class="color-black btn-icon"
          aria-label="prev"
          tabindex="0"
          (click)="onClickNavArrow(); $event.stopPropagation()"
        >
          <sd-icon class="icon-size-s icon-size-md-m" [type]="iconTypes.ARROW_PREV"></sd-icon>
        </button>
      </div>
    }

    <input
      #searchInput
      [maxlength]="maxLength"
      class="search-input color-black"
      aria-label="search"
      type="text"
      id="searchInput"
      autocapitalize="off"
      autocomplete="off"
      [placeholder]="placeholder"
      autocorrect="off"
      enterkeyhint="search"
      spellcheck="false"
      [formControl]="searchInputControl"
      [sdBlurOnTouchOutside]="openedModalWindow()"
      (focus)="onFocusInput()"
      (keydown.enter)="onEnterSearchInput.emit(); searchInput.blur(); close(); closeModal()"
      (keydown.escape)="close(); closeModal()"
      (keydown.arrowup)="focusPreviousChild($event)"
      (keydown.arrowdown)="focusNextChild($event)"
    />

    @if (isLoading) {
      <sd-loader class="search-loader" theme="orange" [size]="obs.isDesktopUp ? 'm' : 's'"></sd-loader>
    } @else if (searchInputControl.value) {
      <button
        class="search-button-cross color-black-warm-400 btn-icon"
        aria-label="reset"
        tabindex="0"
        (click)="searchInput.blur(); clear.emit(); close(); onFocusInputFromModal()"
      >
        <sd-icon class="icon-size-s" [type]="iconTypes.CROSS"></sd-icon>
      </button>

      @if (!obs.isModalType) {
        <div class="search-divider"></div>
      }
    }

    @if (!isLoading && ((!obs.isModalType && searchInputControl.value) || !searchInputControl.value)) {
      <button
        class="search-button-search color-black-warm-400 btn-icon"
        aria-label="search"
        tabindex="0"
        type="submit"
        [disabled]="!searchInputControl.value"
        (click)="onEnterSearchInput.emit(); searchInput.blur(); close()"
      >
        <sd-icon class="icon-size-s icon-size-md-m" type="search"></sd-icon>
      </button>
    }

    @if (!obs.isOpened && !searchInputControl.value && !isLoading && !obs.isModalType) {
      <div class="search-input-right-unfocus">
        <ng-content></ng-content>
      </div>
    }
  </div>

  @if (obs.isOpened && results) {
    <div class="search-results" data-testid="searchResultsSection">
      @if (isEmpty && !isLoading) {
        <div class="search-results-section message-section text-b4-l-300 text-lg-b2-s-300">
          по вашему запросу ничего не найдено
        </div>
      } @else {
        @if (results.taps?.length && query) {
          <div class="search-results-section taps-section" data-testid="searchTapsSection">
            @for (item of results.taps; track item.tap) {
              <label
                #searchResultItem
                [tabindex]="-1"
                for="searchInput"
                class="search-results-item taps-section-item"
                (keydown.escape)="close()"
                (keydown.arrowleft)="focusPreviousChild($event)"
                (keydown.arrowright)="focusNextChild($event)"
                (mousedown)="clickTapItem($event, item)"
                (keydown.enter)="onClickTapItem.emit(item); close(); closeModal()"
              >
                <span class="search-results-item-name text-b4-m-300">{{ item.tap }}</span>
              </label>
            }
          </div>
        }

        @if (results.searchHistory?.length) {
          <div class="search-results-section history-section" data-testid="searchHistorySection">
            @for (item of results.searchHistory; track item.text) {
              <button
                #searchResultItem
                class="search-results-item history-section-item"
                (keydown.escape)="close(); closeModal()"
                (keydown.arrowup)="focusPreviousChild($event)"
                (keydown.arrowdown)="focusNextChild($event)"
                (mousedown)="onClickHistoryItem.emit(item); close(); closeModal()"
                (keydown.enter)="onClickHistoryItem.emit(item); close(); closeModal()"
              >
                <sd-icon class="search-results-item-icon icon-size-xs" type="history"></sd-icon>
                <span class="search-results-item-name history-section-item-name">
                  {{ item.text }}
                </span>
                <sd-icon
                  (mousedown)="$event.stopPropagation(); searchHistoryRemove.emit(item)"
                  class="search-results-item-remove icon-size-xs"
                  type="cross"
                ></sd-icon>
              </button>
            }
          </div>
        }

        @if (results.sts?.length) {
          <div class="search-results-section sts-section" data-testid="searchStsSection">
            @for (item of results.sts; track item.st) {
              <button
                #searchResultItem
                class="search-results-item sts-section-item"
                (mousedown)="onClickStsItem.emit(item); close(); closeModal()"
                (keydown.escape)="close(); closeModal()"
                (keydown.arrowup)="focusPreviousChild($event)"
                (keydown.arrowdown)="focusNextChild($event)"
                (keydown.enter)="onClickStsItem.emit(item); close(); closeModal()"
              >
                <span class="search-results-item-name">
                  {{ item.st }}
                </span>
              </button>
            }
          </div>
        }
      }
    </div>
  }
</form>
